import { render, staticRenderFns } from "./NavigationTemplate.vue?vue&type=template&id=57db430e&scoped=true"
import script from "./NavigationTemplate.vue?vue&type=script&lang=ts"
export * from "./NavigationTemplate.vue?vue&type=script&lang=ts"
import style0 from "./NavigationTemplate.vue?vue&type=style&index=0&id=57db430e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57db430e",
  null
  
)

export default component.exports